export const VIEW_ANGLE_TO_FRAME_NUMBER = {
  1: 34,
  2: 14,
  3: 58,
  4: 34,
  5: 1,
  6: 46,
}

export function frameNumberForViewAngle(viewAngle) {
  return VIEW_ANGLE_TO_FRAME_NUMBER[viewAngle] || 1
}
